import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var text = theme.text;
export var priceModifier = /*#__PURE__*/css(["margin-left:auto;justify-self:flex-end;display:grid;grid-template-columns:1fr 1fr;white-space:nowrap;"]);
export var priceOperator = /*#__PURE__*/css(["font-size:", ";justify-self:flex-end;margin-right:", ";&[data-is-negative='false']{font-size:", ";}"], pxToRem(text.BODY.SM.fontSize), pxToRem(2), pxToRem(text.HEADING.XS.fontSize));